import { InventoryCountItemTemplateUpdatePage } from "@/features/inventory-count-template-item/pages/InventoryCountItemTemplateUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/inventory-count-template-item/$id/update",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["inventory_count_item_template.edit"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: InventoryCountItemTemplateUpdatePage,
});
